const _pendingQuery = ref<string | null>(null);

export function usePendingSearchQuery() {
  const hasPendingQuery = computed(() => _pendingQuery.value !== null);

  function setPendingQuery(query: string): void {
    _pendingQuery.value = query;
  }

  function consumePendingQuery(): string | null {
    const q = _pendingQuery.value;
    _pendingQuery.value = null;
    return q;
  }

  return { hasPendingQuery, setPendingQuery, consumePendingQuery };
}
